import ReactGA from 'react-ga'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { createSink } from 'recompose'

export const trackPage = ({ location }: RouteComponentProps<{}>) => {
  ReactGA.pageview(location.pathname + location.search)
}

export default withRouter(createSink(trackPage as any))
